<template>
    <div>
        <div class="m-2">

            <div class="card m-2 shadow">

                <!--cabezera-->
                <div class="card-header">

                    <div class="d-flex">
                        <div class="flex-fill">
                            <DocumentSearch></DocumentSearch>
                        </div>

                        <div class="float-end">
                            <DocumentPagination></DocumentPagination>
                        </div>

                    </div>

                </div>

                <!--cuerpo-->
                <div class="card-body">

                    <DocumentTable></DocumentTable>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DocumentTable from "@/components/DocumentRepository/DocumentList/Document-table.vue";
import DocumentPagination from "./DocumentList/Document-pagination.vue";
import DocumentSearch from './DocumentList/Document-search.vue'

export default {
    name: 'DocumentList',

    components:{
        DocumentTable,
        DocumentPagination,
        DocumentSearch
    }

}
</script>
<style></style>